import { writable } from "svelte/store";
import { call } from "$lib/Api/Api.svelte";

const zorgAanbiederTypes = writable([]);

const zorgAanbiederTypeStore = {
  subscribe: zorgAanbiederTypes.subscribe,
  load: (id) => {
    return call("zorgaanbieder-types", "query")
      .then((data) => {
        data.sort((a, b) => {
          return a.value < b.value ? -1 : a.value > b.value ? 1 : 0;
        });
        zorgAanbiederTypes.set(data);
      })
      .catch((err) => {});
  },
};

export default zorgAanbiederTypeStore;
